import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setCashoutFinal } from 'services/withDraw'

export default function useSEtFinalCashout() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetCardsPayloadFinal) => {
            return setCashoutFinal(payload)
        },
        onSuccess: (data, variables, payload) => {
            toast.success('برداشت با موفقیت ثبت شد')
            navigate('/funds')
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
